import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { Spinner } from '@tcc/crate';

const baseString = 'vra-display-panel';
const DisplayPanel = ({
  children,
  isExtendedWidth,
  isLoading,
  isMaxWidth
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${baseString}--extended-width`]: isExtendedWidth,
    [`${baseString}--max-width`]: isMaxWidth
  });

  // Hide children if still loading.
  const inner = isLoading ? (<Spinner className='vra-display-panel-loader' size='24' />) : (children);

  return (
    <section
      className={classString}
      data-test-id={`${baseString}`}>
      {inner}
    </section>
  );
};

DisplayPanel.propTypes = {
  children: propTypes.node,
  isExtendedWidth: propTypes.bool,
  isLoading: propTypes.bool,
  isMaxWidth: propTypes.bool
};

export default DisplayPanel;
